// extracted by mini-css-extract-plugin
module.exports = {"btn":"CrossClose_btn__34bdt"};